import {Component, HostListener, Inject, Input, PLATFORM_ID} from '@angular/core';
import {
  ABOUT_ROUTE,
  COMPLAINTS_AND_DISPUTES,
  CONTACT_ROUTE,
  COOKIE_POLICY_ROUTE, GENERAL_CONDITIONS_ROUTE,
  INTELLECTUAL_PROPERTY_ROUTE,
  LANDING_ROUTE,
  LOGIN_ROUTE,
  ORGANISER_DASHBOARD,
  PERSONAL_DATA_PROTECTION,
  PRIVACY_POLICY_ROUTE,
  USER_PROFILE_VIEW_ROUTE
} from "src/app/app-routing.module";
import {Router} from "@angular/router";
import {environment} from "@environment";
import {AuthenticationService, OrganiserRequestService} from "@services";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() displayLargeMobileFooter: boolean = true;

  public static backendVersion?: string | null;
  FooterComponent = FooterComponent;

  environment: any = environment;
  public static clientVersion: string = "1.0.76";

  public currentWindowWidth: number = 0;

  constructor(private router: Router, private authenticationService: AuthenticationService, private organiserRequestService: OrganiserRequestService, @Inject(PLATFORM_ID) private platformId: Object) {

    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  goToPrivacyPolicy() {
    this.router.navigate([PRIVACY_POLICY_ROUTE]);
  }


  goToPrivate() {
    this.router.navigate([this.authenticationService.isAuthenticated() ? USER_PROFILE_VIEW_ROUTE : LOGIN_ROUTE]);
  }

  goToAdmin() {
    if (this.authenticationService.isAdminstrator() || this.authenticationService.isOrganiser()) {
      this.router.navigate([ORGANISER_DASHBOARD]);
    } else if (this.authenticationService.isAuthenticated()) {
      this.organiserRequestService.openOrganiserRequestModal();
    } else {
      this.router.navigate([LOGIN_ROUTE]);
    }
  }


  protected readonly CONTACT_ROUTE: string = CONTACT_ROUTE;
  protected readonly GENERAL_CONDITIONS_ROUTE: string = GENERAL_CONDITIONS_ROUTE;
  protected readonly COOKIE_POLICY_ROUTE: string = COOKIE_POLICY_ROUTE;
  protected readonly INTELLECTUAL_PROPERTY_ROUTE: string = INTELLECTUAL_PROPERTY_ROUTE;
  protected readonly ABOUT_ROUTE: string = ABOUT_ROUTE;
  protected readonly COMPLAINTS_AND_DISPUTES: string = COMPLAINTS_AND_DISPUTES;
  protected readonly PERSONAL_DATA_PROTECTION: string = PERSONAL_DATA_PROTECTION;
  protected readonly LANDING_ROUTE: string = LANDING_ROUTE
  protected readonly ORGANISER_DASHBOARD: string = ORGANISER_DASHBOARD

  @HostListener('window:resize')
  onResize(): void {
    this.currentWindowWidth = window.innerWidth
  }

  getClientVersion() {
    return FooterComponent.clientVersion;
  }

}
